import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService } from '#services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';

@Component({
  selector: 'app-header',
  imports: [TranslatePipe],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  private userAuthService = inject(AuthService);

  protected fullName = '';
  protected hasAccess = false;

  constructor() {
    this.userAuthService.userDetails$
      .pipe(
        filter(userDetails => userDetails !== null),
        takeUntilDestroyed()
      )
      .subscribe(({ username: fullName = '', hasAccess = false }) => {
        this.hasAccess = hasAccess;
        this.fullName = fullName;
      });
  }
}
